export default __webpack_public_path__ + "media/6fded79d24ddd81077b8d35e2a30166c21249f9758b03fc92f38fd35b401cc80.svg";